export default __webpack_public_path__ + "static/media/chevron-up-white.8101feca.svg";